import React, {PureComponent} from 'react';
import {connect} from 'dva';
import {routerRedux} from 'dva/router';
import {Spin, Tabs} from 'antd';
import {PATH_HOME} from '../../utils/constants';
import {TriangleWrap} from '../Widgets';
import './index.less';
import {FormattedMessage, injectIntl} from 'react-intl';

class MenuContainer extends PureComponent {
  componentWillUpdate(nextProps) {
    const {
      menus,
      dispatch,
      location: { pathname },
      parentPath
    } = nextProps;
    if (pathname === parentPath) {
      //因为不确定当前用户的角色有什么菜单，所以点击父级菜单时需要一次重定向
      const childMenus = this.getChildMenus({ menus, parentPath });
      if (childMenus.length > 0) {
        const { url } = childMenus[0];
        dispatch(routerRedux.push(`${PATH_HOME}${url}`));
      }
    }
  }
  render() {
    const {
      menus,
      dispatch,
      location,
      loading,
      children,
      parentPath
    } = this.props;
    const { pathname } = location;
    const childMenus = this.getChildMenus({ menus, parentPath });
    return (
      <div className="container-left menu-container">
        <div className="container-user">
          <Spin spinning={loading} size="large">
            <div className="container-desk">
              <div className="user-information">
                <div className="user-right">
                  <div className="right-title">
                    {/*<div className="tabs-container">*/}
                    {/*  {childMenus.map(menu => {*/}
                    {/*    const name = menu.name;*/}
                    {/*    const path = `${PATH_HOME}${menu.url}`;*/}
                    {/*    return (*/}
                    {/*      <div*/}
                    {/*        className={`tab ${*/}
                    {/*          path === pathname ? 'tab-active' : ''*/}
                    {/*        }`}*/}
                    {/*        title={name}*/}
                    {/*        onClick={() => dispatch(routerRedux.push(path))}*/}
                    {/*        key={path}*/}
                    {/*      >*/}
                    {/*        {name}*/}
                    {/*      </div>*/}
                    {/*    );*/}
                    {/*  })}*/}
                    {/*</div>*/}
                    <TriangleWrap className="children-wrap">
                      <div className="header-div">
                        <Tabs size="large" activeKey={pathname} onTabClick={key=>{
                          dispatch(routerRedux.push(key));
                        }}>
                          {childMenus.map(menu => {
                            const name = <FormattedMessage id={menu.name} />;
                            const path = `${PATH_HOME}${menu.url}`;
                            return (
                              <Tabs.TabPane
                                tab={name}
                                key={path}
                              />
                            );
                          })}
                        </Tabs>
                      </div>
                      <div style={{paddingLeft:"10px"}}>
                        {children}
                      </div>
                    </TriangleWrap>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
    );
  }

  getChildMenus = ({ menus, parentPath }) => {
    const { data: menuArr = [] } = menus;
    const menuConfig = menuArr.find(
      menu => menu.url && `${PATH_HOME}${menu.url}` === parentPath
    );
    if (menuConfig && menuConfig.children) {
      return menuConfig.children;
    } else {
      return [];
    }
  };
}

const mapStateToProps = state => {
  return {
    menus: state.menu.menus,
    loading: state.loading.global
  };
};

export default connect(mapStateToProps)(MenuContainer);



// WEBPACK FOOTER //
// ./src/components/MenuContainer/index.js